import { ResponseGenerator } from 'common/type';
import { call, put, takeLatest } from 'redux-saga/effects';

import { getFilterOutputAPI, getFilterOutputSearchAPI, getSQLKnrAPI, getUserGroupAPI } from './api';
import {
  filterOutputReport,
  filterOutputReportSuccess,
  filterOutputReportFailure,
  getUserGroupSuccess,
  getSqlKnrSuccess,
  getUserGroup,
  getSqlKnr,
  getOutputDataSearchFailure,
  getOutputDataSearchSuccess,
  getOutputDataSearch,
} from './slice';

function* filterOutputReportSearchSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getFilterOutputAPI, payload);

    yield put(filterOutputReportSuccess(response));
  } catch (error) {
    yield put(
      filterOutputReportFailure({
        loading: false,
      })
    );
  }
}
function* getUserGroupSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getUserGroupAPI, payload);
    yield put(getUserGroupSuccess(response));
  } catch (error) {
    console.log(error);
  }
}

function* getSqlKnrAPISaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getSQLKnrAPI, payload);
    yield put(getSqlKnrSuccess(response));
  } catch (error) {
    console.log(error);
  }
}

function* getOutputReportSearchSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getFilterOutputSearchAPI, payload);
    yield put(getOutputDataSearchSuccess(response));
  } catch (error) {
    yield put(
      getOutputDataSearchFailure({
        loading: false,
      })
    );
  }
}

function* watchOutputReportMaster() {
  yield takeLatest(filterOutputReport, filterOutputReportSearchSaga);
  yield takeLatest(getOutputDataSearch, getOutputReportSearchSaga);
  yield takeLatest(getUserGroup, getUserGroupSaga);
  yield takeLatest(getSqlKnr, getSqlKnrAPISaga);
}

export default watchOutputReportMaster;
